import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 text-xs font-mono text-gray-500 text-center bg-gray-950/50 rounded border border-gray-800/60">
          {this.props.fallback || 'Component failed to load'}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
